import request from '../api-request';
import { Responsibility } from 'manage-settings/manage-users/manage-users.types';

export function getResponsibilities() {
  return request<Responsibility[]>(`/api/responsibilities`);
}
